import { useLocalization } from "../../hooks/useLocalization";
import { IMatch } from "../../types/types";
import { HomeMatchSection } from "./HomeMatchSection";

interface RecentGamesProps {
  playedMatches: IMatch[] | undefined;
}

export const RecentGames = ({ playedMatches }: RecentGamesProps) => {
  const { strings } = useLocalization();

  return (
    <HomeMatchSection
      title={strings.RECENT_GAMES.TITLE}
      matches={playedMatches}
      mode="played"
      scheduleLinkLabel={strings.RECENT_GAMES.VIEW_ALL}
      scheduleLinkTo="/results"
      emptyContent={
        <p className="m-0 text-center font-jetbrains opacity-80">
          {strings.RECENT_GAMES.NO_RECENT_GAMES_AVAILABLE}
        </p>
      }
    />
  );
};
